import React from 'react';

export const FillPowerLeftPanel = () => {
  return (
    <div className="il-add grey" style={{ backgroundImage: `url("/img/fillpower/fillpower-lower-one.jpg")`}}></div>
  );
};